<template>
  <v-container class="pa-0">
    <v-select
      loading
      auto-select-first
      no-data-text="No profiles found"
      return-object
      cache-items
      outlined
      append-icon="none"
      label="Select preset profile"
      persistent-placeholder
      :menu-props="{ bottom: true, offsetY: true }"
    />

    <v-row
      align="center"
      no-gutters
    >
      <span class="text-subtitle-1 font-weight-light mr-1">Preset profile</span>
      <v-divider />
    </v-row>

    <v-row>
      <v-skeleton-loader
        type="list-item-two-line"
        width="100%"
      />
    </v-row>
    <v-row>
      <v-skeleton-loader
        type="list-item-two-line"
        width="100%"
        class="mb-2"
      />
    </v-row>
    <v-row>
      <v-skeleton-loader
        type="list-item-two-line"
        width="100%"
        class="mb-2"
      />
    </v-row>
    <v-row>
      <v-skeleton-loader
        type="list-item-two-line"
        width="100%"
        class="mb-2"
      />
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PresetsLoadingView",
};
</script>
